import React from 'react'
import { EnhancedColumn } from 'react-table'

export default function Header({ column: { label, getResizerProps, getHeaderProps } }:{ column: EnhancedColumn }) {
  return (
    <div {...getHeaderProps({ style: { display: 'inline-block' } })} className="th noselect">
      <div className="th-content">
        {label}
      </div>
      <div {...getResizerProps()} className="resizer" />
    </div>
  )
}
